import { useState } from "react";

const CustomChartCard = ({
  title,
  overall,
  legendData,
  legendValue,
  onCardClick,
  onStatusClick,
}) => {
  const [selectedStatus, setSelectedStatus] = useState(null);

  const colorMap = {
    Open: "#6929E2",
    Progress: "#A677FF",
    Hold: "#CCACE6",
    Closed: "#CBAFFF",
    Completed: "#E4D6FF",
  };
  // const colorMap = {
  //   Open: "#6929E2",
  //   Progress: "#9A65FF",
  //   Hold: "#BF9DFF",
  //   Closed: "#DCC9FF",
  // };

  const segments = Object.keys(legendData).map((key) => ({
    status: key.charAt(0).toUpperCase() + key.slice(1), // capitalize
    value: legendData[key],
    color: colorMap[key.charAt(0).toUpperCase() + key.slice(1)],
  }));

  const legendConfig = [
    { title: "Open", color: "#6929E2", count: legendValue.open },
    { title: "Progress", color: "#A677FF", count: legendValue.progress },
    { title: "Hold", color: "#CCACE6", count: legendValue.hold },
    { title: "Closed", color: "#CBAFFF", count: legendValue.closed },
    { title: "Completed", color: "#E4D6FF", count: legendValue.completed },
  ];

  // const legendConfig = [
  //   { title: "Open", color: "#6929E2", count: legendValue.open },
  //   { title: "Progress", color: "#9A65FF", count: legendValue.progress },
  //   { title: "Hold", color: "#BF9DFF", count: legendValue.hold },
  //   { title: "Closed", color: "#DCC9FF", count: legendValue.closed },
  //   { title: "Closed", color: "#DCC9FF", count: legendValue.closed },
  // ];

  const handleLegendClick = (title) => {
    setSelectedStatus((prev) => (prev === title ? null : title)); // toggle
    onStatusClick(title);
  };

  return (
    <div
      className="location-cont mt-2"
      style={{ padding: "20px", cursor: "pointer" }}
      onClick={() => onCardClick()}
    >
      <div className="sub-title mb-2">{title} ({overall})</div>

      {/* Segmented Bar */}
      <div className="segmented-bar">
        {segments.map((seg, i) => {
          const isActive =
            selectedStatus === null || selectedStatus === seg.status;

          return (
            <div
              key={i}
              className="segment"
              style={{
                width: `${seg.value}%`,
                backgroundColor: isActive ? seg.color : "#E6E6E6",
                opacity: isActive ? 1 : 0.4,
                transition: "all 0.3s ease",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleLegendClick(seg.status);
              }}
            />
          );
        })}
      </div>

      {/* Legend Section */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "8px",
          gap: "26px",
        }}
      >
        {legendConfig.map((item, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              opacity:
                selectedStatus === null || selectedStatus === item.title
                  ? 1
                  : 0.4,
              transition: "opacity 0.3s ease",
            }}
            onClick={(e) => {
              e.stopPropagation();
              handleLegendClick(item.title);
            }}
          >
            <div
              className="legend"
              style={{ backgroundColor: item.color }}
            />
            <div className="legend-text ml-1">{item.title}</div>
            <div className="legend-count ml-2">{item.count}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomChartCard;
